<template>
  <div class="editorProcess">
    <div 
      class="canvas" 
      id="editor-process" 
      ref="processCanvas" 
      @dragover.prevent 
      @dragenter.prevent 
      @drop.prevent="onDrop($event)" 
    >
    </div>

    <editorOptions :diagram="diagram" >
      <div class="diagramAddOn">
        <div class="overviewWrap">
<!--          <button class="mapOpen"  @click="overviewStatus = !overviewStatus">Map</button>-->
        </div>
        <div class="overview_wrap">
          <div class="overview" :class="{on: overviewStatus}">
              <div class="title_area">
                  <strong class="tit">Map</strong>
              </div>
              <div id="editor-overview" class="editor_overview"></div>
          </div>
        </div>
      </div>
    </editorOptions>
    <contextMenuTemplate @callOpenDictionaryPopup="callOpenDictionaryPopup" @contextMounted="getContext" :slctType="slctType"/>
    <Loading :visible="loading" />
    <TagOptionPopWrap @setPosition="setPosition"/>
    <TagOptionPopTagList @callOpenDictionaryPopup="callOpenDictionaryPopup" />
    <BalloonTemplateData />
    <SaveLogPopup :crntObj="SaveLogPopupObj" />
    <releasePopup :openFlag.sync="PublishPopupObj.openBln" @saveDiagram="saveDiagram" @orderApply="orderApply"/>
    <LogListPopup :crntObj="LogListPopupObj" />
    <CreateOrConnectPopup :crntObj="CreateOrConnectPopup" @connect-protocol="connectProtocol($event)" />
    <dictionaryPopup :crntObj="dictionaryPopup" :checkedTagDictionaryId.sync = "checkedTagDictionaryId"/>

    <ProcessSearch :type="'onlyProtocol'" 
      @select-protocol="selectProtocol($event)"
      :searchLinkData="searchLinkData"
      @setMethod="getChildMethods($event)"
    />

    <editor-btm-option 
      :openLogListPopup="openLogListPopup" 
      :openSaveLogPopup="openSaveLogPopup" 
      :openPublishPopup="openPublishPopup"
      :processData="processData"
      @gridVisible="gridVisible"
      @saveRequest="saveDiagram"
      @endEditProcess="endEditProcess"
      @orderApply="orderApply"
    />
<!--    <div class="undoRedoWrap" v-if="!getProcessReadOnly">
      <button @click="undoHandler" class="undo" :class="undoClass">undo</button>
      <button @click="redoHandler" class="redo" :class="redoClass">redo</button>
    </div>-->

    <div v-show="editStatusAlert" class="modalPopupLayout active">
      <div class="contentWrap">
        <h2 class="title" style="text-align: center">{{ editStatusTitle }}</h2>
        <div class="content">
          <p class="content" style="text-align: center; width: 300px" v-html="editStatusContent"></p>
        </div>
        <div class="ctrl" style="margin-top : 20px">
          <button class="sm_btn color_2" @click="$router.go( $router.currentRoute )">확인</button>
        </div>
      </div>
    </div>
    <!-- <print-test /> -->
  </div>
</template>

<script>
import { tagsArr } from "@/plugins/wApi/colors";
import { createNamespacedHelpers } from 'vuex';
import CommNew, { commNewMapMutations , commNewMapGetters } from "@processEditor/CommNew";
import { TagAddPopCommMapMutations } from "@TagAddPop/TagAddPopComm"; 
import mixin from "@/mixins/process";
import GO from "gojs";
import { v4 } from "uuid";

import editorOptions from './options.vue';
import contextMenuTemplate from './contextMenu.vue';
import BalloonTemplateData from './BalloonTemplateData';

import Loading from '@common/loading.vue'
import TagOptionPopWrap from '@components/TagAddPop' ; 
import TagOptionPopTagList from '@components/TagAddPop/TagOptionPopTagList' ; 
import { nodePasteRule } from "@tiptap/core";
import SaveLogPopup from './comp/SaveLogPopup' ; 
import releasePopup from '@nav_process/Editor/comp/releasePopup' ; 
import LogListPopup from './comp/LogListPopup' ; 
import CreateOrConnectPopup from './comp/CreateOrConnectPopup' ; 
import dictionaryPopup from '@modal/dictionaryPopup' ; 
import EditorBtmOption from '@common/EditorBtmOption' ;
import PrintTest from '@common/PrintTest' ;
import {setNodeOrderByBFS} from '@/util/HubHandsonTable';

import {checkProtocolLink, protocolsInLink} from '@mixins/makeLinkInfo.js';

const ProcessSelector = createNamespacedHelpers('ProcessSearch');
const ProcessEditor = createNamespacedHelpers('ProcessEditor');
const goMake = GO.GraphObject.make;

const Dictionary = createNamespacedHelpers("Dictionary");
const Hub = createNamespacedHelpers('Hub');

const copyCommandHandler = (diagram, copyAndPasteLinkAdd) => {
  const cmd = diagram.commandHandler
  let nodeDatas = [], linkDatas = []
  let event, control, copyStatus = false

  const copyNode = () => {
    let keyData = {}, newNodeList = [], newLinkList=[]
    let copyNodeArr = [];
    diagram.startTransaction("Add State");
    for(let node of nodeDatas) {
      let newData = Object.assign({}, node)
      let pos = newData.position.split(' ')
      newData.key = v4();
      newData.tagKey = v4();
      newData.nodeOrder = null;
      newData.nodeForceOrder = null;
      newData.position = `${Number(pos[0])-10} ${Number(pos[1])-10}` 
      node.position = `${Number(pos[0])-10} ${Number(pos[1])-10}` 
      delete newData.__gohashid
      keyData[node.key] = newData.key
      newNodeList.push(newData)
      copyNodeArr.push({originKey : node.key, newKey:newData.key});
    }
    copyAndPasteLinkAdd(copyNodeArr);
    diagram.model.addNodeDataCollection(newNodeList)
    for(let link of linkDatas) {
      let newLink = Object.assign({}, link)
      let from = keyData[newLink.from]
      let to = keyData[newLink.to]
      if(from && to) {
        newLink.from = keyData[newLink.from]
        newLink.to = keyData[newLink.to]
        delete newLink.__gohashid;
        newLinkList.push(newLink)
      }
    }
    if(newLinkList.length > 0) diagram.model.addLinkDataCollection(newLinkList)
    diagram.commitTransaction("Add State");
    diagram.layout.invalidateLayout();
    return {
      nodes: newNodeList,
      links: newLinkList
    }
  }
  
  const copyCommand = () => {
    event = diagram.lastInput
    control = event.control || event.meta

    if(control && event.key === 'C') {
      nodeDatas = []
      linkDatas = []
      if(diagram.selection.size === 0) {
        copyStatus = false
        return false
      }
      diagram.selection.each( (node)=>{
        if(node instanceof GO.Node) {
          nodeDatas.push(node.data)
        }
        if(node instanceof GO.Link) {
          linkDatas.push(node.data)
        }
      } )
      copyStatus = true
      return true
    }
  }

  const pasteCommand = () => {
    event = diagram.lastInput
    control = event.control || event.meta
    if(control && event.key === 'V' && copyStatus === true) {
      const newNodes = copyNode(nodeDatas, linkDatas, diagram)
      const selectNodes = []
      for(let node of newNodes.nodes ) {
        selectNodes.push(diagram.findNodeForKey(node.key))
      }
      diagram.selectCollection(selectNodes)
      return true
    }else {
      return false
    }
  }

  const clickPoint = () => {}

  return {
    diagram, copyCommand, pasteCommand,
    nodeDatas, linkDatas
  }
}

export default {
  beforeDestroy () {
    window.removeEventListener( 'keydown' , this.keydownHandler ) ;
    if ( this.user.name != 'AxiosError' ) {
      this.cleanup();
    }
  } ,

  mixins:[mixin , CommNew],

  components : {
    CreateOrConnectPopup ,
    Loading , 
    editorOptions , 
    contextMenuTemplate , 
    TagOptionPopWrap , 
    TagOptionPopTagList , 
    BalloonTemplateData , 
    SaveLogPopup , 
    releasePopup ,
    LogListPopup , 
    EditorBtmOption , 
    PrintTest, 
    dictionaryPopup,
  } , 
  
  data () {
    return {
      pendingBln : false ,
      processData: {},
      goMake: {},
      diagram: {},
      overview: {},
      overviewStatus: false,
      loading: false,
      contextMenu: {},
      autoSaveTimer: undefined,
      crntNode : null , 
      SaveLogPopupObj : {
        openBln : false , 
        closeHandler : _=> this.SaveLogPopupObj.openBln = false , 
      } , 
      PublishPopupObj : {
        openBln : false , 
        publishType : true,
        processType : null,
        closeHandler : _=> this.PublishPopupObj.openBln = false , 
      } ,       
      LogListPopupObj : {
        openBln : false , 
        closeHandler : _=> this.LogListPopupObj.openBln = false , 
      } , 
      CreateOrConnectPopup : {
        openBln : false , 
        closeHandler : _=> this.CreateOrConnectPopup.openBln = false , 
      } , 
      dictionaryPopup : {
        openBln : false , 
        closeHandler : ()=>{
          this.dictionaryPopup.openBln = false;
          this.resetTagAddBtnNew();
        }, 
      } , 
      slctType : 'single' , 
      connectProtocolMethod : {},
      searchLinkData : {},
      gridVisibleOption : true,
      editStatusAlert : false,
      editStatusTitle : "",
      editStatusContent : "",
      networkErrorCount : 0,
      pollingEndSwitch : false,
      pos: {},
      accordionFlag: false,
      checkedTagDictionaryId : null, // 아코디언으로 딕셔너리 추가시에만 사용
    }
  },

  computed: {
    ...commNewMapGetters([
      'status' , 
    ]) , 
    ...ProcessSelector.mapGetters(['getSelectedProcess']),
    ...ProcessEditor.mapState({
      selectedNode: state => state.selectedNode
    }) ,
    useTags () {
      return this.crntElement?.useTags ; 
    } ,
    moveOptWrap () {
      return this.status.nodeinfoViewBln ? 'move' : null ; 
    } ,
    ...Dictionary.mapGetters(["getTagAddBtnNewData","getTagAddBtnNewFunc","getTagAddBtnNewOpenFlag"]),
    undoClass() {
      let cmd = this.diagram.commandHandler
      if (!cmd) return;
      return cmd.canUndo() ? null : 'unused';
    },
    redoClass() {
      let cmd = this.diagram.commandHandler
      if (!cmd) return;
      return cmd.canRedo() ? null : 'unused';
    }, 
  },
  props :{
    editKey : {
      type : String,
      default : null
    }
  },
  watch: {
    getSelectedProcess(value) {
      this.processData = value;
      this.getProcessDetail();
    }, 
    'PROCESS_INFO': {
      handler(value) {
        this.processData = { ...this.processData , value } ; 

        if ( value.nodes && value.nodes.length == 0 ) {
          this.saveEmptyImg() ; 
        }
        this.getProcessDetail() ; 
      },
    },
    dragTag : {
      deep : true, 
      handler ({ dragBln , dropBln , tagElemClone }) {
        if ( dropBln ) {
          this.tagDrop() ; 
        }
      } , 
    } , 
    'status.logHistoryBln' : {
			deep : true , 
			immediate : false , 
			handler ( bln ) {
        if ( bln ) {
          this.getProcessDetail()
        }
			} , 
		} , 
    getTagAddBtnNewOpenFlag(value){
      if(value){
        this.accordionFlag = true;
        this.checkedTagDictionaryId = null;
        this.callOpenDictionaryPopup(this.getTagAddBtnNewData, this.getTagAddBtnNewFunc);
      }else{
        this.accordionFlag = false;
        this.dictionaryPopup.openBln = false;
      }
    },
  },
  async mounted() {
    await this.$nextTick() ;
    Object.assign(this.processData, this.PROCESS_INFO)
    this.diagramInit();
    await this.getProcessDetail() ;
    this.copyNpasteHandler = copyCommandHandler(this.diagram, this.copyAndPasteLinkAdd)
    window.addEventListener( 'keydown' , this.keydownHandler ) ;
    //tag이벤트 TagAddPop를 init 하기위한 상태값 변경
    this.setProcessReadOnly(false);
    await this.polling();

  },
  methods: {
    ...commNewMapMutations([
      'openDocumentOption' , 
      'templatePopupViewToggleHandler' , 
      'updateStatus' , 
      'setCrntDiagram' , 
      'initDiagram'
    ]),
    ...ProcessEditor.mapMutations(['selectNode', 'setProcessId', 'setDiagram', 'setProcessDetail']),
    ...TagAddPopCommMapMutations([
      'setTagOptionPopAddListViewBln' , 
      'setCrntTagType' , 
      'setCallbackFunc' , 
    ]) ,
    ...Dictionary.mapActions([
      "resetTagAddBtnNew"
    ]),
    ...Hub.mapActions([
      'updateSelectedProcess','fetchCheckProcessProp'
    ]),
    /*async unloadHandler(event){
      event.preventDefault();
      const response = await this.$wApi.simultaneous.aliveCheck({
         relativeId: this.$route.query.processId,
         editKey : this.editKey
       });
      this.$router.go( this.$router.currentRoute ) ;
    },*/
    getChildMethods(methods){
      this.connectProtocolMethod = methods;
    },
    connectProtocol(linkData){
      // 프로토콜 생성 가능한지 확인값.
      let protocolCreateFlag = linkData.EQUIPMENT && (linkData.ANALYSIS || linkData.MEASUREMENT) && linkData.MATERIAL ? true : false;
      this.setProtocolCreateFlag(protocolCreateFlag);
      // 프로토콜 연결 or 생성 or 이동 팝업 open 이전에 validation check.
      if(!protocolCreateFlag) {
        let alertMsg = `<b>공정도에서 프로토콜을 생성 또는 연결하기 위해서는 
                          <br>재료, 목적, 장비가 모두 연결되어 있어야 됩니다.
                        </b>
                        <br><br><font color="red">※ 프로토콜 작성 후 재료, 목적, 장비를 선택하시려면
                                              <br>   게이트웨이로 이동 후 프로토콜을 생성해 주세요.
                                </font>
                        `;
        window.alert(alertMsg);
      }else {
        this.searchLinkData = linkData;
        this.connectProtocolMethod.show();
      }
    },
    selectProtocol(data){
      console.log( "resultData", data )
    },
    openSaveLogPopup () {
      this.SaveLogPopupObj.openBln = true ; 
    } , 
    openLogListPopup () {
      this.LogListPopupObj.openBln = true ; 
    } , 
    openPublishPopup () {
        this.PublishPopupObj.openBln = true ;
        this.PublishPopupObj.processType = this.PROCESS_INFO.processType;
      },
    openCreateOrConnectPopup() {
      this.CreateOrConnectPopup.openBln = true;
    },
    opendictionaryPopup() {
      this.dictionaryPopup.openBln = false; // 이전 데이터가 setting되어있다면 watch를 사용해서 초기화 하기 위한 목적
      this.dictionaryPopup.openBln = true;
    },
    keydownHandler ( e ) {
      if ( this.loading ) return ; 
      let { ctrlKey , key } = e ; 
			if ( ctrlKey ) {
				switch ( key ) {
					case 's' : 
                      e.preventDefault() ;	
                      //this.saveDiagram() ;
                      this.orderApply() ;
                      break ; 
                    case 'r' :
                      e.preventDefault() ;  
                      this.$router.go( this.$router.currentRoute ) ; 
                      break ; 
				}
			}
    } , 
    async getProcessDetail(){
      this.loading = true
      let response = await this.$wApi.process.detail(null, this.PROCESS_INFO.processId)

      const data = JSON.parse(response.json)
      if ( data == null ) {
        Object.assign(
          this.processData, { 
            ...this.processData , 
            links : [] , 
            nodes : [] , 
          }
        )
      } else {
        Object.assign(this.processData, data)
      }
      //console.log( "this.processData", this.processData.nodes )
      let equipmentTags = this.processData.nodes.filter(o=>o.category==='EQUIPMENT');
      let {protocols} = this.processData.value == null || this.processData.value == "undefined"? this.processData : this.processData.value;
      this.processData.nodes.filter(o=>o.category==='PROTOCOL').forEach((node)=>{
        node.protocol = 0;
      });

      //노드 순서 적용
      let keyLinkRes = await this.$wApi.dictionary.getDictionaryKeyLinksByProcessId({
        processId : this.PROCESS_INFO.processId
      });
      
      // 연결 프로토콜 개수
      let protocolDataList = await this.$wApi.process.getProtocols(null, this.PROCESS_INFO.processId);

      this.processData.nodes.forEach((node,index) => {
        let link = keyLinkRes.filter(o => o.tagKey === node.key)
        if(link.length > 0){
          node.nodeOrder = link[0]?.nodeOrder;
          node.nodeForceOrder = link[0]?.nodeForceOrder;
        }
        // 연결 프로토콜 개수
        if(protocolDataList != null) {
          const protocolCount = protocolDataList.filter(o => o.innerKeyOfProtocol == node.key).length;
          node.protocolData = {cnt: protocolCount};
          node.protocol = protocolCount;
        }
      });

      //프로토콜 수량 표시
/*      if( protocols ){
        let fullProtocols = [];
        for( let equipment of equipmentTags  ){
          let fullProtocol = protocols.filter(o=>o.innerKeyOfProtocol==equipment.key && (o.onlyProtocolPublicActive > 0 || o.showMode));
          if( fullProtocol.length > 0 ){
            fullProtocols.push({ 
              key : equipment.key,
              count : fullProtocol.length //연결된 프로토콜 수량을 저장해요. 추후 하나의 프로토콜태그에 다수의 프로콜이 연결되는 상황에 대비
            } );
          }
        }

        for( let fullProtocol of fullProtocols ){
          let protocolKey = this.processData.links.find(o=>o.from===fullProtocol.key).to;
          this.processData.nodes.find(o=>o.key === protocolKey && o.category==='PROTOCOL').protocol = fullProtocol.count;
        }
      }*/

      if ( this.processData.nodes && this.processData.nodes.length == 0 ) {
        this.saveEmptyImg() ; 
      }
      await this.updateSelectedProcess(this.processData);
      this.setProcessDetail(this.processData)
      this.setModel(this.processData)
      this.loading = false
    },
    tagChangeHandler ( tagInfo ) {
      //console.log( '-------------- tagChangeHandler in' ) ;
      let { crntNode } = this ; 

      this.diagram.model.commit( m => {
        let { nodeDataArray } = m ; 
        let modifyNode = null ; 
        nodeDataArray.filter( node => {
          if ( crntNode.category == node.category && crntNode.key == node.key ) {
            modifyNode = node ; 
          }
        }) ; 
        let { tagShape , id , name , tagType, newKey } = tagInfo ;

        const useTag = {
          id , 
          idUser : this.USER_INFO.id , 
          name , 
          tagShape : tagShape , 
          tagType , 
        } ; 
        console.log( 'modifyNode : ' , modifyNode ) ; 
        this.deleteUseTags({ category : modifyNode.category , id : modifyNode.tagId }) ; 
        this.addUseTags({ category : tagType , useTag }) ; 

        m.setDataProperty( modifyNode , 'shape' , tagShape ) ; 
        m.setDataProperty( modifyNode , 'tagId' , id ) ; 
        m.setDataProperty( modifyNode , 'text' , name ) ;
        m.setDataProperty( modifyNode , 'key' , newKey ) ;

        // console.log( this ) ; 
        // this.elements[4].status.tagListView = 'exist-tags' ; 
      }, "flash");
    } , 
    diagramInit() {
      // diagram 설정
      // console.log("Diagram Initialization start : ", this.contextMenu)
      const nodeTemplateMapped = new GO.Map();
      const nodeGroupTemplateMapped = new GO.Map();

      // 재귀 함수를 사용한 하위 노드 탐색. 공정, 재료 하위는 제외
      let findChildNodes = (currentNode, childNodes) => {
        let links = currentNode.findLinksOutOf();
        links.each(function (link) {
          let targetNode = link.toNode;
          if (!(targetNode.data.category == "PROCESS" || targetNode.data.category == "MATERIAL")) {
            childNodes.add(targetNode);
            findChildNodes(targetNode, childNodes)
          }
        });
      };

      // 노드를 넘겨주면 하위 노드중 공정, 재료의 하위 노드가 아닌 노드를 선택해 주는 함수.
      let selectedSubNodes = (diagram, currentNode)=>{
        if (currentNode instanceof go.Node) {
          let childNodes = new go.Set();
          findChildNodes(currentNode, childNodes);
          childNodes.add(currentNode);
          diagram.selectCollection(childNodes);
        } else {
          return;
        }
      };

      // 하위 노드중 공정 재료를 제외한 노드를 접는 function.
      let treeExpandedAction = (currentNode) => {
          let childNodes = new go.Set();
          findChildNodes(currentNode, childNodes);
          childNodes.each(function (node) {
              node.visible = currentNode.data.treeExpanded;
          });
          // 버튼 모양 업데이트
          const button = currentNode.findObject("Tree");
          if (button) {
              button.figure = currentNode.data.treeExpanded ? "MinusLine" : "PlusLine";
          }
      }

      // group node를 선택시 group에 포함된 노드중 재료인 노드의 하위 노드를 선택하는 함수.(재료 자식 노드 중 공정, 재료와 그 하위 노드는 제외.)
      let selectedGroupChild = (diagram, currentNode)=>{
        if (currentNode instanceof go.Node) {
          var subGraphParts = currentNode.findSubGraphParts();
          let childNodes = new go.Set();
          subGraphParts.each(function (part) {
            if (part instanceof go.Node) {
              var node = part;
              diagram.findNodeForKey(node.key);
              findChildNodes(node, childNodes);
              childNodes.add(node);
            }
          });
          childNodes.add(currentNode);
          diagram.selectCollection(childNodes);
        } else {
          return;
        }
      };

      let doubleClickDefault = async (event , node) => {
        let { data , data : { category, tagId }} = node ;
        this.crntNode = data ;
        
        /*if(!this.checkUseProtocol()){
          window.alert("<b>선택하신 노드중 프로토콜과 연결된 노드가 있습니다.<br/>이미 작성된 프로토콜이 존재하는경우<br/>연결된 재료,목적,장비를 수정할 수 없습니다.</b>");
          return;
        }*/

        //공정도 속성이 존재하는 경우 사전 변경 불가!
        const processPropsLength = await this.fetchCheckProcessProp({key: node.key, processId: this.$route.query.processId}); 
        if(processPropsLength > 0){
          await window.alert("속성이 존재하는 경우, 동일 사전 내에서만 표시어를 변경할 수 있습니다.<br/>다른 사전으로 변경하려면 노드 삭제 후 새로 생성해 주세요.");
          this.dictionaryPopup.changeOnlyDisplayWord = true;
          this.dictionaryPopup.category = category;
          this.dictionaryPopup.key = node.key;
          this.dictionaryPopup.tagId = tagId;
          this.dictionaryPopup.processId = this.processId;
          this.dictionaryPopup.changeTagFunc = this.tagChangeHandler; 
          this.opendictionaryPopup();
        }else{
          this.dictionaryPopup.changeOnlyDisplayWord = false;
          this.dictionaryPopup.category = category;
          this.dictionaryPopup.key = node.key;
          this.dictionaryPopup.tagId = tagId;
          this.dictionaryPopup.processId = this.processId;
          this.dictionaryPopup.changeTagFunc = this.tagChangeHandler; 
          this.opendictionaryPopup();
        }
      }
      let doubleClickProtocol = (event, node) => {

        let key = null;
        let hasProtocol = null;
        let cNum = 0;
        
        const getFromNode = function(node) {
          if(node == null) return null;
          const it = node.findNodesInto(); // 연결된 상위 노드를 모두 확인.
          let firstNode = null;
          while (it.next()) {
            const incomingNode = it.value;
            firstNode = incomingNode;
            break; // 첫번쨰 상위 노드만 확인. => 기존 데이터 중 부모:자식이 n:1인 경우. (부모:자식 => 1:n이 정상적인 데이터임.)
          }
          return firstNode;
        };

        const protocolNode  = node;
        const EquipmentNode = getFromNode(node);
        const PurposeNode   = getFromNode(EquipmentNode);
        const MaterialNode  = getFromNode(PurposeNode);
        
        node.linksConnected.iterator.each((linkNode) => {
          if (cNum != 0) return;
          key = linkNode.fromNode.data.key;
          hasProtocol = linkNode.fromNode.data.hasProtocol;
          cNum += 1;
        });

        
          // 프로토콜 생성 가능한지 확인값.
          let protocolCreateFlag = false;
          // 프로토콜 연결 or 생성 or 이동 팝업 open 이전에 validation check.
          if(!(protocolNode   != null
             && EquipmentNode != null
             && PurposeNode   != null
             && MaterialNode  != null)){
            let alertMsg = `<b>공정도에서 프로토콜을 생성 또는 연결하기 위해서는 
                              <br>재료, 목적, 장비가 모두 연결되어 있어야 됩니다.
                            </b>
                            <br><br><font color="red">※ 프로토콜 작성 후 재료, 목적, 장비를 선택하시려면
                                                  <br>   게이트웨이로 이동 후 프로토콜을 생성해 주세요.
                                    </font>
                            `;
            this.setProtocolCreateFlag(protocolCreateFlag);
            window.alert(alertMsg);
            return;
          }else {
            this.saveDiagram() ;
            protocolCreateFlag = true;
            this.setProtocolCreateFlag(protocolCreateFlag);
            // 프로토콜 연결 or 생성 or 이동 팝업 open.
            this.openCreateOrConnectPopup();
            this.CreateOrConnectPopup.eventNode = node;
            this.CreateOrConnectPopup.processId = this.processId;
            return;
          }
        
      }

      this.releaseDiagram();
      this.refreshNodeStyleMap();
      this.nodeStyleMap.forEach((nodeData, key)=>{
        nodeTemplateMapped.add(
          `${key}`,
          goMake(
            GO.Node, 'Spot', {
              cursor: 'pointer',
              margin:2,
              locationSpot: GO.Spot.Center,
              selectionAdornmentTemplate : this.nodeStyle.selection(),
              click: (event, node ) =>{
                node.data.visible = null;
                this.selectNode(node.data);
              },
              doubleClick: (() => {
                return key === 'PROTOCOL' ? doubleClickProtocol : doubleClickDefault
              })() , 
              contextMenu: this.contextMenu,
              linkValidation: (fromnode, fromport, tonode, toport)=> {
                return fromnode.data.linkValidation.indexOf(tonode.data.category) !== -1
              }
            },
            new GO.Binding("location", "position", GO.Point.parse).makeTwoWay(GO.Point.stringify),
            goMake(GO.Panel,'Auto', 
              ...nodeData.nodeTemplate,
            ),
          ),
        )
      })

      this.nodeGroupStyleMap.forEach((groupData, key)=>{
        nodeGroupTemplateMapped.add(
          `${key}`,
          goMake(go.Group, "Vertical",
              {
                  selectionObjectName: "Group",
                  ungroupable: true,
                  contextMenu: this.contextMenu,
              },
              goMake(go.TextBlock,
                  {
                      font: "bold 14px 'fontello', 'Pretendard', 'NanumSquare', sans-serif",
                      isMultiline: false,
                      editable: true
                  },
                  new go.Binding("text", "text").makeTwoWay(),
              ),
              goMake(go.Panel, "Auto",
                  { name: "PANEL" },
                  goMake(go.Shape, "RoundedRectangle",
                  {
                      fill: "rgba(128,128,128,0.2)",
                      portId: "", cursor: "pointer",
                      fromLinkable: false, fromLinkableSelfNode: false, fromLinkableDuplicates: false,
                      toLinkable: false, toLinkableSelfNode: false, toLinkableDuplicates: false
                  }),
                  goMake(go.Placeholder, { margin: 10, background: "transparent" })
              ),
              goMake("SubGraphExpanderButton", { alignment: go.Spot.TopLeft, "ButtonBorder.figure": "RoundedRectangle" }),
          )
        )
      });

      const diagramGrid = new go.Panel("Grid", { gridCellSize: new go.Size(10, 10) })
          .add(new go.Shape("LineH", { stroke: "lightgray", strokeWidth: 0.3 }))
          .add(new go.Shape("LineV", { stroke: "lightgray", strokeWidth: 0.3 }));

      this.diagram = new GO.Diagram("editor-process", {
        layout: goMake(GO.TreeLayout, {
          isOngoing: false,
          isInitial: false
        }),
        // layout: goMake(GO.TreeLayout),
        "undoManager.isEnabled": true,
        // 확대 정도
        scale: 1,
        maxScale: 3,
        minScale: 0.2,
        scrollMargin: 15,
        nodeTemplateMap: nodeTemplateMapped,
        groupTemplateMap: nodeGroupTemplateMapped,
        linkTemplate: this.linkTemplate,
        grid: diagramGrid,
      });

      //디버깅용!
      this.diagram.addDiagramListener("ObjectSingleClicked", function(e) {
          var selectedNodes = e.diagram.selection; //현재 선택된 요소들의 컬렉션

          selectedNodes.each(function(node) {
              var data = node.data; // 선택된 노드의 데이터
              var key = data.key; // 선택된 노드의 키 속성 값
              console.log(JSON.stringify(data));
          });
      });

      this.diagram.toolManager.draggingTool.isGridSnapEnabled = true
      this.diagram.isVirtualized  = false;
      this.diagram.contextMenu = this.contextMenu;
      this.diagram.allowCopy = false;
      this.diagram.padding = new GO.Margin(120, 0, 150, 0);

      this.diagram.toolManager.draggingTool.doMouseMove = function() {
          if (this.isActive && this.diagram.lastInput.shift) {
              this.gridSnapCellSize = new go.Size(1, 1);
          } else {
              this.gridSnapCellSize = new go.Size(10, 10);
          }
          go.DraggingTool.prototype.doMouseMove.call(this);
      };

      this.diagram.toolManager.doMouseDown = function () {
          go.ToolManager.prototype.doMouseDown.call(this);
          if (this.diagram.lastInput.left && !this.diagram.lastInput.control) {
              let lastMouseDownPoint = this.diagram.lastInput.documentPoint;
              let currentNode = this.diagram.findPartAt(lastMouseDownPoint, false);
              if(currentNode){
                  if(currentNode.data.isGroup){
                      selectedGroupChild(this.diagram, currentNode);
                  }else{
                      selectedSubNodes(this.diagram, currentNode);
                  }
              }
          }
      }

      this.diagram.toolManager.draggingTool.doMouseUp = function () {
          go.DraggingTool.prototype.doMouseUp.call(this);
          if (this.diagram.lastInput.left && !this.diagram.lastInput.control) {
              let currentNode  = this.diagram.findPartAt(this.diagram.lastInput.documentPoint, false);
              if (currentNode instanceof go.Node) {
                const setNode = new go.Set();
                let nodesToDeselect = this.diagram.selection;
                this.diagram.clearSelection(nodesToDeselect);
                this.diagram.selectCollection(setNode.add(currentNode));
              }
          }
      }

      this.diagram.toolManager.doMouseUp = () => {
          go.ToolManager.prototype.doMouseUp.call(this.diagram.toolManager);
          if (this.diagram.lastInput.left && !this.diagram.lastInput.control) {
              let currentNode  = this.diagram.findPartAt(this.diagram.lastInput.documentPoint, false);
              if (currentNode instanceof go.Node) {
                const setNode = new go.Set();
                let nodesToDeselect = this.diagram.selection;
                this.diagram.clearSelection(nodesToDeselect);
                this.diagram.selectCollection(setNode.add(currentNode));
              }
          }else if (this.diagram.lastInput.right) {
            let currentNode  = this.diagram.findPartAt(this.diagram.lastInput.documentPoint, false);
            // 우클릭이며 event 대상이 gojs의 객체(노드 & 링크)가 아닐때 selection 초기화.
            if(!(currentNode instanceof go.Node) && !(currentNode instanceof go.Link)){
              this.diagram.clearSelection(this.diagram.selection);
              // store의 selectNode 초기화 > sidebar 초기화를 위한 작업.
              this.selectNode({visible:false});
            }
          }
      }

      this.diagram.addDiagramListener('InitialLayoutCompleted', (event) => {
        // console.log('Diagram InitialLayoutCompleted : ', event)
        event.diagram.nodes.each((node)=>{
          if( 
            node.data.category === 'PROTOCOL' &&
            node.data.protocol &&
            typeof node.data.protocol === 'number' &&
            node.data.protocol > 0
          ){
            node.findObject('protocolCount').text = node.data.protocol;
            // console.log( "node.data", node.findObject('TargetNode') ) 
          }
          if(node.data.treeExpanded == false) {
            // editor가 그려진 후 확장값이 false(확장되지 않은 상태)인 노드는 하위 노드를 숨기고 버튼이 보이도록 설정.
            treeExpandedAction(node);
            node.findObject("TREEBUTTON").opacity = 1;
          }
        })
      })

      this.diagram.addDiagramListener('ChangedSelection', (event, node) => {
        if (this.diagram.selection.size === 0) {
          this.selectNode({visible: false})
        };

        // 컨텍스트 메뉴를 싱글/멀티/그룹으로 나눈다.
        if (this.diagram.selection.size === 1) {
          const selectedNode = this.diagram.selection.first();
          this.slctType = (selectedNode instanceof go.Group) ? 'group' : 'single';
        } else if (this.diagram.selection.size > 1) {
          this.slctType = 'multiple';
        } else {
          this.slctType = 'single';
        }
      });

      this.diagram.addDiagramListener('SelectionDeleted', (event, node) => {
        console.log(' diagram 삭제 이벤트( SelectionDeleted ) ')
      })
      this.diagram.addDiagramListener('ClipboardChanged', (event, nodes) => {
        event.diagram.selection.each( (item)=>{
          console.log(item)
        } )
        console.log(' clipbord change : ')
      })
      this.diagram.addDiagramListener('SelectionCopied', (event, node) => {
        console.log('Selection Copied : ', event.subject)
        for(let items = event.subject.iterator; items.next();) {
          console.log(items.value.data)
        }
        // ctrl + 마우스 를 이용한 노드 및 링크 복사 할 경우 key 재설정
      })

      // 링크 추가 이벤트 리스너 정의
      this.diagram.addDiagramListener("LinkDrawn", (e) => {
        const link = e.subject; // 새로 추가된 링크

        // 이미 해당 노드에 연결된 링크가 있는지 확인
        const sourceNode = link.fromNode;
        const targetNode = link.toNode;
        // 장비 => 프로토콜 연결시 프로토콜에 이미 연결된 장비가 존재하면 연결을 불가능하도록. 1 : 1.
        if (sourceNode.data.category == "EQUIPMENT" && targetNode.data.category == "PROTOCOL" && sourceNode.findNodesOutOf().count > 1) {
          this.diagram.remove(link);
        // 목적 => 장비 연결시 장비에 이미 연결된 목적이 존재하면 연결을 불가능하도록.
        } else if (targetNode.data.category == "EQUIPMENT" && targetNode.findNodesInto().count > 1) {
          this.diagram.remove(link);
        // 재료 => 목적 연결시 목적에 이미 연결된 재료가 존재하면 연결을 불가능하도록.
        } else if ( (targetNode.data.category == "MEASUREMENT" || targetNode.data.category == "ANALYSIS" ) && targetNode.findNodesInto().count > 1) { 
          this.diagram.remove(link);
        }
      });
      
      // 키 커멘드 입력 이벤트 제어
      this.diagram.commandHandler.doKeyDown = async (e) => {
        let cmd = this.diagram.commandHandler, status = false;
        var lastInput = this.diagram.lastInput;
        
        status = this.copyNpasteHandler.copyCommand()
        status = this.copyNpasteHandler.pasteCommand()

        if (lastInput.event.key === "Delete") {
          let nodeFlag = false;
          this.diagram.selection.each(part => {
            if (part instanceof go.Node) {
              nodeFlag = true;
              //console.log("This is a Node:", part.data); // part.data를 사용해 노드의 데이터 확인 가능
            } else if (part instanceof go.Link) {
              //console.log("This is a Link:", part.data); // part.data를 사용해 링크의 데이터 확인 가능
            } else {
              //console.log("Unknown part type:", part);
            }
          });
          if(nodeFlag){
            const flag = await confirm("노드 삭제 시 입력된 실험입력데이터와 적용속성은 복구가 불가능합니다.\n 삭제하시겠습니까?");
            if(!flag)return;
          }
          this.diagram.commandHandler.deleteSelection();
          await this.saveDiagram();
        }
        
        if(status == false && lastInput.event.key != "Delete") {
          GO.CommandHandler.prototype.doKeyDown.call(cmd)
        }
        
        // 붙여넣기 직후 저장.
        if(lastInput.control && lastInput.key === 'V') {
          this.saveDiagram();
        }
      }
      this.diagram.addModelChangedListener((e)=> {
        if(!e.isTransactionFinished) return

        // return ; 
        // if(!e.isTransactionFinished) return
        // console.log( "------------------")
        // 자동저장 타이머
        if(this.autoSaveTimer) { 
          clearTimeout(this.autoSaveTimer) 
        }
        this.saveTimer()
      });
      // Overview 설정(minimap)
      this.overview = new GO.Overview('editor-overview', {
        observed: this.diagram
      })
      this.setDiagram(this.diagram)
      this.setCrntDiagram( this.diagram ) ; 

      this.$emit("update-diagram", this.diagram);
      this.initDiagram( this.diagram )
    },
   
    setModel(item) {
      // console.log('Set model: ', item)
      if ( item.links == undefined ) {
        item.links = [] ; 
      }
      if ( item.nodes == undefined ) {
        item.nodes = [] ; 
      }

      for(let nodeData of item.nodes){
        if(!nodeData.isGroup){
          nodeData.linkValidation = this.nodeStyleMap.get(nodeData.category).linkValidation
          nodeData.label = this.nodeStyleMap.get(nodeData.category).label
          if(!nodeData.tagKey) {
            nodeData.tagKey = nodeData.key || v4()
          }
        }
      }
      this.diagram.model = new GO.GraphLinksModel(
        {
          nodeDataArray: item.nodes,
          linkDataArray: item.links,
        }
      );
      this.loading = false;
    },
    saveTimer () {
      this.autoSaveTimer = setTimeout( _=> {
        this.saveDiagram() ; 
      } , this.saveDuration ) ; 
    },
    async saveEmptyImg () {
      const toDataURL = ( src ) => {
        return new Promise( resolve => {
          let img = new Image ; 
          img.crossOrigin = 'Anonymous';
          img.onload = function() {
            let canvas = document.createElement('CANVAS');
            let ctx = canvas.getContext('2d');
            let dataURL;
            canvas.height = this.naturalHeight;
            canvas.width = this.naturalWidth;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL("image/jpeg");
            resolve( dataURL ) ; 
          };
          img.src = src;
        })
      } ; 
      const rslt = await toDataURL( require( '@/assets/image/empty-image.jpg') ) ; 
      let imageBase64 = rslt.replace('data:image/jpeg;base64,','')

      // 현재 템플릿 테이블은 준비중
      try {
        const responseImage = await this.$wApi.process.thumbnail.put({
          processId: this.processId,
          thumbnail: imageBase64,
        }, this.processId)
      } catch (error) {
        console.log(error)
      }
    } , 

    async saveDiagram(releaseFlag) {
      
      if(this.PROCESS_INFO.processType == "ONLY_PROTOCOL"){ // only_protocol의 경우 공정도를 자동 저장하지 않는다.
        return;
      }
      
      console.log( 'saveDiagram in' ) ; 
      // 다이어그램 이미지 생성 (base64)
      let bound = this.diagram.documentBounds;
      let diagramImage = this.diagram.makeImage({
        // scale: 0.4,
        scale: 1,
        size: new go.Size(bound.width+200, bound.height+200),
        background: '#fff',
        type: "image/jpeg"
      });
      // console.log( "this.diagram.model.nodeDataArray", this.diagram.model.nodeDataArray )
      // console.log( "this.diagram.model.linkDataArray", this.diagram.model.linkDataArray )
      // console.log('##### : ', bound)
      // console.log('##### : ', diagramImage)
      // console.log('##### : ', diagramImage.src)
      const nodeData = {
        json: {
          nodes : this.diagram.model.nodeDataArray,
          links : this.diagram.model.linkDataArray,
        },
      }
      //노드 순서 적용
      setNodeOrderByBFS(nodeData.json.nodes, nodeData.json.links,this.diagram.model);
      this.loading = true;
      let imageBase64 = diagramImage.src.replace('data:image/jpeg;base64,','');
      // console.log( "nodeData.json", nodeData.json )
      // 불 필요한 코드 주석 (빈 공정도 저장)
      // if( nodeData.json.nodes.length == 0 ) {
      //   clearTimeout( this.autoSaveTimer ) ;
      //   //alert("노드 생성 후 저장해주세요.");
      //   this.loading = false;
      //   return;
      // } //빠른 페이지 이동인해 데이터를 못가져왔을때 return

      try {
        //readonly 옵션 확인
        //console.log( 'saveDiagram call try this.getProcessReadOnly is ' + this.getProcessReadOnly) ;
        if(this.getProcessReadOnly){
          this.loading = false;
          return;
        }

        //동시수정 방지. editKey로 유효한 키인지 확인 => 유효하지않을 경우 저장X
        const res = await this.$wApi.simultaneous.saveable({
           editKey : this.editKey
        });
        if(!res.isSaveable){
          this.loading = false;
          return;
        }

        const response = await this.$wApi.process.put( {...nodeData,active:true}, this.processId);

      } catch (error) {
        console.log(error)
        this.loading = false;
      }
      // 현재 템플릿 테이블은 준비중

      /** 로그 등록 */
      await this.$wApi.trace.log({
        type : 'PD', //PD 공정도, PR 프로토콜
        code : 'M', //N 생성 M 수정 S 검색 R 조회
        subCode : '01',
        keyword : '',
        result : 0,
        ptlId : this.processId
      });
      /** 로그 등록 */          
      try {
        const responseImage = await this.$wApi.process.thumbnail.put({
          processId: this.processId,
          thumbnail: imageBase64,
        }, this.processId)
      } catch (error) {
        console.log(error)
        this.loading = false;
      }
      
      /*자동저장 로그 insert*/
      if(releaseFlag != true) { // 공개 팝업 open 직전 자동 저장의 경우 modify version을 상승시키지 않음. (공개 완료 후 backend에서 log insert)
        const autoSaveResPonse = await this.$wApi.process.autoSave.create({processId: this.processId});
      }
      
      clearTimeout( this.autoSaveTimer ) ; 
      this.loading = false;

      if(this.status.issueListStatus.reload) {
        await this.status.issueListStatus.reload();
      }
      
      window.wToast("공정도 자동저장을 완료하였습니다.", {
        variant: "wtoast-bg",
      }) ; 
    }, 
    async tagDrop () {
      try {
        // undo를 위한 추가기능 상황 시작
        this.diagram.startTransaction("Add State");
        
        let {
          data : {
            label , 
            tagId , 
            category , 
            tagShape , 
            hasProtocol , 
          } , 
          pos : { x , y } , 
          tagElemClone , 
        } = this.dragTag ; 
  
        // console.log( "this.dragTag", this.dragTag )
  
        console.log({
          data : this.dragTag.data , 
          hasProtocol : this.dragTag.data.hasProtocol , 
        })
      
        // const element = this.elements.filter(( element , idx ) => element.category == category )[0] ; 
  
        const useTag = {
          id : parseInt( tagId ) , 
          idUser : this.USER_INFO.id , 
          name : label , 
          tagShape : tagShape , 
          tagType : category , 
        } ; 
        this.addUseTags({ category , useTag }) ; 
  
        let processCanvas = this.$refs.processCanvas ; 
        let left = processCanvas.getBoundingClientRect().left ;
        let top = processCanvas.getBoundingClientRect().top ;
  
        let halfWidth = 0;
        let halfHeight = 0;
        // let halfHeight = 32/2;
  
        if ( tagElemClone ) tagElemClone.remove() ; 
  
        if ( !category ) return ; 
        const position = this.diagram.transformViewToDoc( new GO.Point(x - left - halfWidth, y - top - halfHeight) ) ; 
        const tagKey = v4();
        const key = tagKey;
  
        // 새 node 설정
        const newNode = {
          shape: "null",
          position: `${position.x} ${position.y}`,
          text: label,
          category,
          tagId,
          key,
          tagKey,
          // 노드 연결 시 정해진 링크만 연결 되어야 함
          // 해당 정보는 setModal에서는 입력 시 생성이 되며 드래그로 추가 시 정보를 노드에 추가해 주어야 함
          // 해당 정보는 process.js 에 this.nodeStyleMap 에 정의 되어 있으며
          // makeNodeStyleMap 참고
          linkValidation : this.nodeStyleMap.get(category).linkValidation
        } ; 
  
        // console.log('new Node : ', category)
        // console.log({ newNode })

        // 노드 추가
        this.addNode( newNode , hasProtocol ) ;

        // undo를 위한 추가기능 상황 종료
        this.diagram.commitTransaction("Add State");
        this.diagram.layout.invalidateLayout();
        this.saveDiagram();
        // 여기서 accordion추가의 경우 key link update.
        if (this.checkedTagDictionaryId) {
          // key link table insert or update
          const keyLinkInsertOrUpdate = await this.$wApi.dictionary.changeLinkKey({
            processId: this.processId
            , key: newNode.key
            , dictionaryId: this.checkedTagDictionaryId
            , tagId : tagId
          });

          if (keyLinkInsertOrUpdate.error) {
            throw new Error("key link table insert or update error");
          }
          this.checkedTagDictionaryId = null;
        }
        return newNode;
      }catch (e) {
        window.alert("태그 추가 중 오류가 발생했습니다.")
      }
    } , 
    addNode ( newNode , hasProtocol ) {
      const { model } = this.diagram ;
      if(newNode.key) {
        newNode.tagKey = v4()
      }
      model.addNodeData( newNode ) ; 
    } , 
    getContext(data) {
      this.contextMenu = data;
      // console.log('Get context : ', data);
    },
    copyNpasteHandler() {},
    templateToggleHandler () {
      let { updateStatus } = this ; 
      // updateStatus({ key : 'templatePopupViewBln' , bln : true }) ; 
      updateStatus({ templatePopupViewBln : true }) ; 
    } , 
    approvalRequestToggleHandler () {
      let { updateStatus } = this ; 
      updateStatus({ templatePopupViewBln : false }) ; 
    } ,
    gridVisible(){
      this.diagram.grid.visible = this.gridVisibleOption = !this.gridVisibleOption
    },
    async orderApply(){
      await this.saveDiagram();
      await this.getProcessDetail();
    },
    checkUseProtocol(){
      // 재귀 함수를 사용한 하위 노드 탐색. 공정, 재료 하위는 제외
      let findChildNodes = (currentNode, childNodes) => {
        let links = currentNode.findLinksOutOf();
        links.each(function (link) {
          let targetNode = link.toNode;
          if (!(targetNode.data.category == "PROCESS" || targetNode.data.category == "MATERIAL")) {
            if(targetNode.data.protocol > 0) {
              childNodes.add(targetNode);
            }
            findChildNodes(targetNode, childNodes)
          }
        });
      };
      let useProtocolStatus = true;
      let selectedNodes = new go.Set(); // 선택된 노드를 저장할 Set 객체
      this.diagram.selection.each(node => {
        if (node instanceof go.Node) {
          selectedNodes.add(node); // 선택된 노드 추가
        } else if (node instanceof go.Link) {
          selectedNodes.add(node.toNode); // 링크의 도착 노드 추가
        }
      });
      selectedNodes.each(node => {
        if(useProtocolStatus) {
          if(node.data.category == "PROTOCOL" && node.data.protocol > 0){
            useProtocolStatus = false;
            return;
          }
          let lowestNodes = new go.Set(); // 최하위 노드를 저장할 Set 객체
          findChildNodes(node,lowestNodes);
          if (lowestNodes.size > 0) {
            useProtocolStatus = false;
            return;
          }
        }else{
          return;
        }
      });
      if(useProtocolStatus){
        return true;
      }else {
        return false;
      }
    },
    async test(content){
        // 이미 다이어그램에 그려진 노드에 key 속성 추가
/*        const nodeData = this.getDiagram.model.findNodeDataForKey(this.getSelectedNode.key); // 해당 노드의 데이터를 찾음
        if (nodeData && this.input.forceOrderUseYn) {
          this.getDiagram.model.setDataProperty(nodeData, "nodeForceOrder",parseInt(this.input.nodeForceOrder));  // 해당 노드에 "nodeForceOrder" 속성 추가
          this.getDiagram.model.setDataProperty(nodeData, "nodeOrder",parseInt(this.input.nodeForceOrder));  // 해당 노드에 "nodeForceOrder" 속성 추가
        }else if(nodeData && !this.input.forceOrderUseYn){
          this.getDiagram.model.setDataProperty(nodeData, "nodeForceOrder", null);
        }*/
    },
    async endEditProcess(){
      if (!this.networkErrorCount > 0) {
        await this.saveDiagram();
        //key update.
        const keyResponse = await this.$wApi.simultaneous.statusUpdate({
          relativeId: this.$route.query.processId,
          editType: "PROCESS",
          editable: true, //수정가능상태로 변경
        });
      }
      this.editStatusAlert = false;
      this.$router.go( this.$router.currentRoute ) ;
       /*try {
         const response = await this.$wApi.simultaneous.aliveCheck({
           relativeId: this.$route.query.processId,
           editKey : this.editKey,
         });
         if(!response.error){
           //window.removeEventListener('beforeunload', this.unloadHandler);
           await this.saveDiagram() ;
           this.$router.go( this.$router.currentRoute ) ;
         }
       }catch (e){
         console.log(e)
       }*/
    },
    async cleanup(){
      await this.saveDiagram();
      this.pollingEndSwitch = true;
      this.setProcessReadOnly(true);
    },
    async aliveCheck (){
       try{
         this.loading = true
         const response = await this.$wApi.simultaneous.aliveCheck({
           relativeId: this.$route.query.processId,
           editKey : this.editKey,
         });
         //console.log('aliveCheck response ',response,'this.editKey = ',this.editKey)
        //TODO 네트워크 끊김에 따른 후처리 and editkey 유효성 검사를 통한 reload 필요
         if(!response.isEditMode){
           //editkey 유효성 검사 실패에 따른 reload
           this.editStatusTitle = "유효하지 않은 세션";
           this.editStatusContent = "유효하지않은 세션입니다.<br/>관리모드로 새로고침됩니다.";
           this.editStatusAlert = true;
         }
         this.networkErrorCount = 0;
       }catch(e){
        console.log(e)
        ++this.networkErrorCount;
        if(this.networkErrorCount == 5) {
          this.editStatusTitle = "네트워크 연결시도 실패";
          this.editStatusContent = "네트워크 연결 5회 실패하였습니다.<br/>네트워크 상태를 확인해주세요.";
          this.editStatusAlert = true;
        }else{
          alert(`네트워크가 연결되어있지 않습니다.<br/>연결시도 ${this.networkErrorCount}회 실패`);
        }
       }finally {
         this.loading = false
       }
    },
    async polling() {
      const timeOut = ms => new Promise(resolve => setTimeout(resolve,ms));
      await timeOut(Math.floor(this.editDuration/2));
      if(this.pollingEndSwitch){
        return;
      }
      await this.aliveCheck();
      if(this.networkErrorCount < 5 ){
        await this.polling();
      }
    },
    setPosition(pos){
      this.pos = pos;
    },
    callOpenDictionaryPopup(searchData, changeFunctionParam) {
      if (changeFunctionParam && this.accordionFlag != true) {
        this.dictionaryPopup.category = searchData.category;
        this.dictionaryPopup.key = searchData.key;
        this.dictionaryPopup.tagId = searchData.tagId;
        this.dictionaryPopup.changeOnlyDisplayWord = searchData.changeOnlyDisplayWord;
        this.dictionaryPopup.processId = this.processId;
        this.dictionaryPopup.changeTagFunc = changeFunctionParam; 
      } else if (this.accordionFlag != true) {
        let pos = this.pos;
        let dragTag = this.dragTag;
        let tempTagDrop = this.tagDrop;
        this.dictionaryPopup.changeTagFunc = async function (tagInfo) {
          await Object.assign(dragTag, {
            ...dragTag,
            dropBln: false,
            pos: pos,
            data: {
              label: tagInfo.name,
              tagId: String(tagInfo.id),
              category: tagInfo.tagType,
              tagShape: null,
              hasProtocol: false,
            },
          });
          let newNode = await tempTagDrop();
          return newNode.key;
        };
        this.dictionaryPopup.category = searchData.type; 
        this.dictionaryPopup.key = null;
        this.dictionaryPopup.tagId = null;
        this.dictionaryPopup.changeOnlyDisplayWord = false;
        this.dictionaryPopup.processId = this.processId;
      } else {
        this.dictionaryPopup.category = searchData.type; 
        this.dictionaryPopup.key = null;
        this.dictionaryPopup.tagId = null;
        this.dictionaryPopup.changeOnlyDisplayWord = false;
        this.dictionaryPopup.processId = this.processId;
        this.dictionaryPopup.changeTagFunc = changeFunctionParam; 
      }
      this.opendictionaryPopup();
    },
    undoHandler() {
      let cmd = this.diagram.commandHandler
      if (cmd.canUndo()) {
        cmd.undo();
        this.saveDiagram() ;
      }
    },
    redoHandler() {
      let cmd = this.diagram.commandHandler
      if (cmd.canRedo()) {
        cmd.redo();
        this.saveDiagram() ;
      }
    },

    async copyAndPasteLinkAdd(nodeArr){
      try {
        for(let node of nodeArr){
          const response = await this.$wApi.dictionary.getDictionaryKeyLinkByProcessIdAndKey({
            key: node.originKey,
            processId: this.$route.query.processId
          });
          //console.log(response)
          const keyLinkInsertOrUpdate = await this.$wApi.dictionary.changeLinkKey({
              processId: this.$route.query.processId
              , key: node.newKey
              , dictionaryId: response.dictionaryId
              , tagId : response.tagId
          });
        }
        //console.log(keyLinkInsertOrUpdate);
      }catch (error){
        console.log(error);
      }
    },
  // end of methods
  } ,
}

</script>

<style lang="scss">
  @import 'index.scss';
  div.editorProcess {z-index:90 !important;}
</style>
